import { axiosInstanceIservices } from 'lib/services/config/axios-config'
import { TRestResponse } from '../../restApi/restApi.types'
import { TGenerateRepToken, TGenerateRepTokenParams } from './types'
import { useMutation } from 'react-query'

const generateRepToken = async (
  params: TGenerateRepTokenParams
): Promise<TRestResponse<TGenerateRepToken>> => {
  try {
    const { surgeryId, canAddAsset, companyId, companyName } = params
    const { data: responseData } = await axiosInstanceIservices.post<
      TRestResponse<TGenerateRepToken>
    >(`/reps/generate-guest-rep-token`, {
      surgeryId,
      canAddAsset,
      companyId,
      companyName,
    })
    return {
      success: responseData.success,
      message: responseData.message,
      data: responseData.data || undefined,
    }
  } catch (error) {
    console.error(error)
    return {
      success: false,
      message: (error as Error).message,
    }
  }
}

export const useGenerateRepToken = () => {
  return useMutation<
    TRestResponse<TGenerateRepToken>,
    Error,
    TGenerateRepTokenParams
  >((params: TGenerateRepTokenParams) => {
    return generateRepToken(params)
  })
}
